const onlineLearning = {
  path: 'onlineLearning/:myClassId',
  props: true,
  component: resolve => require(['../../../../components/pages/student_user/onlineLearning'], resolve)
}
export default onlineLearning
